const BOTTOM_MOBILE_HEIGHT = 54;
const BOTTOM_TABLET_HEIGHT = 108;
const BOTTOM_LAPTOP_HEIGHT = 108;
const BOTTOM_DESKTOP_HEIGHT = 108;

export const productTileBottomHeight = [
  `${BOTTOM_MOBILE_HEIGHT}px`,
  `${BOTTOM_MOBILE_HEIGHT}px`,
  `${BOTTOM_TABLET_HEIGHT}px`,
  `${BOTTOM_LAPTOP_HEIGHT}px`,
  `${BOTTOM_DESKTOP_HEIGHT}px`,
  `${BOTTOM_DESKTOP_HEIGHT}px`,
];

/** @deprecated not used with real tile anymore. TODO: adjust ProductTileSkeleton */
export const ratio = [
  0.98, /// xs
  0.97, /// sm
  1.2, /// md
  1.3, /// lg
  1.15, // xl
  1.15, // xxl
];
